// GfxDrawing.js


//------------------------------------------------------------
//
//	GfxPath (object/API)
//
//------------------------------------------------------------
/*-----------------------------------------------*
 * GfxPath: list of operations (move, line, arc, quadbez, close)
 * describing a path
 *
 * [
 *    {op, x, y, p1, p2, p3 }
 *    ...
 * ] 
 *
 * Functions:
 *
 * 
 *-----------------------------------------------*/

function GfxPath()
{
	this.gfxpath = [];
}

GfxPath.Op = Object.freeze({
		NOOP:	0,
		MOVETO:	1,
		LINETO:	2,
		ARC:	3,
		QUADBEZ:4,
		CLOSE:  5,
		CIRCLE: 6,
		TEXT:   7
	});

GfxPath.prototype.Is2D = function()
{
	return true;
}

GfxPath.prototype.GetOpCount = function()
{
	return this.gfxpath.length;
}

GfxPath.prototype.GetOp = function(opIdx)
{
	var op = undefined;

	if (opIdx >= 0 && opIdx < this.gfxpath.length)
		op = this.gfxpath[opIdx];

	return op;
}

GfxPath.prototype.Close = function(pt)
{
	let op = {op: GfxPath.Op.CLOSE };
	this.gfxpath.push(op);
}

GfxPath.prototype.MoveTo = function(pt)
{
	let op = {op: GfxPath.Op.MOVETO, pt:{x:pt.x, y:pt.y} };
	this.gfxpath.push(op);
}

GfxPath.prototype.LineTo = function(pt)
{
	let op = {op: GfxPath.Op.LINETO, pt:{x:pt.x, y:pt.y} };
	this.gfxpath.push(op);
}

GfxPath.prototype.Arc = function(pt, radius, startAngle, endAngle, ccw)
{
	let op = {op: GfxPath.Op.ARC, pt:{x:pt.x, y:pt.y}, r:radius, start:startAngle, end:endAngle, ccw:ccw };
	this.gfxpath.push(op);
}

GfxPath.prototype.Circle = function(pt, radius)
{
	let op = {op: GfxPath.Op.CIRCLE, pt:{x:pt.x, y:pt.y}, r:radius };
	this.gfxpath.push(op);
}

GfxPath.prototype.Text = function(pt, str)
{
	let op = {op: GfxPath.Op.TEXT, pt:{x:pt.x, y:pt.y}, str:str };
	this.gfxpath.push(op);
}


//-------------------------------------------------------------------------------------
//	Add Perforation
//-------------------------------------------------------------------------------------
GfxPath.prototype.AddPerforation = function(ptA, ptB, spacing, radius, config = undefined)
{
	let len = Math.sqrt((ptA.x - ptB.x) * (ptA.x - ptB.x) + (ptA.y - ptB.y) * (ptA.y - ptB.y));
	var uv = {x: (ptB.x - ptA.x)/len, y: (ptB.y - ptA.y)/len};
	var count = Math.floor(len/spacing);
	var pt = {};
	var distribute = (config != undefined) ? config.distribute : undefined;
	var circles = (config != undefined && config.style == "circles") ? true : false;
	
	if (distribute)
	{
		// Distribute the perforation evenly. The spacing will not be exactly 'spacing', 
		// but the spacing between the dots and between the first/last dot and the start/end
		// of the line will be the same.
		// Note that we start at 1 and end at count-1 because we know that 0 and count will
		// be exactly on the start and end of the line, which is unnecessary
		for (var kk = 1; kk < count; kk++)
		{
			pt.x = kk * (ptB.x - ptA.x)/count + ptA.x;
			pt.y = kk * (ptB.y - ptA.y)/count + ptA.y;
			
			if (circles)
				this.Circle(pt, radius);
			else
			{
				this.MoveTo({x:pt.x - uv.x * radius, y:pt.y - uv.y * radius});
				this.LineTo({x:pt.x + uv.x * radius, y:pt.y + uv.y * radius});
			}
		}
	}
	else
	{
		// Keep the spacing exactly at 'spacing'
		// If the offset is zero, then the line is a multiple of 'spacing', otherwise
		// offset indicates how much to shift the first dot. Also, if offset is zero,
		// then we don't do the first and last dot, since these will be on the start 
		// and end of the line.
		var offset = (len - count * spacing)/2;
		var adjust = (offset == 0) ? 1 : 0;
		var start;
		
		if (len == count * spacing)
		{
			offset = 0;
			start = 1;
		}
		else
		{
			offset = (len - count * spacing)/2 + spacing/2;
			start = 0;
		}
		
		for (var kk = start; kk < count; kk++)
		{
			pt.x = (offset + kk * spacing) * uv.x + ptA.x;
			pt.y = (offset + kk * spacing) * uv.y + ptA.y;
			if (circles)
				this.Circle(pt, radius);
			else
			{
				this.MoveTo({x:pt.x - uv.x * radius, y:pt.y - uv.y * radius});
				this.LineTo({x:pt.x + uv.x * radius, y:pt.y + uv.y * radius});
			}
		}
	}
}


//-------------------------------------------------------------------------------------
//	Find Bounds
//-------------------------------------------------------------------------------------
GfxPath.prototype.FindBounds = function(bounds = undefined, margin = 0)
{
	for (var i = 0; i < this.gfxpath.length; i++)
	{
		var minx = undefined;
		var miny = undefined;
		var maxx = undefined;
		var maxy = undefined;
		
		let op = this.gfxpath[i];
		
		if (op.op == GfxPath.Op.MOVETO || op.op == GfxPath.Op.LINETO)
		{
			minx = op.pt.x;
			miny = op.pt.y;
			maxx = op.pt.x;
			maxy = op.pt.y;
		}
		else if (op.op == GfxPath.Op.ARC || op.op == GfxPath.Op.CIRCLE)
		{
			minx = op.pt.x - op.r;
			miny = op.pt.y - op.r;
			maxx = op.pt.x + op.r;
			maxy = op.pt.y + op.r;
		}
		
		// Adjust the min and max of this op by the provided margin
		// (This is used by the caller to take the line width into account for stroked paths)
		minx -= margin;
		miny -= margin;
		maxx += margin;
		maxy += margin;
		
		if (bounds == undefined && minx != undefined)
		{
			bounds = {min:{x:minx, y:miny}, max:{x:maxx, y:maxy}}
		}
		else
		{
			if (bounds.min.x > minx)
				bounds.min.x = minx;
				
			if (bounds.min.y > miny)
				bounds.min.y = miny;
				
			if (bounds.max.x < maxx)
				bounds.max.x = maxx;
				
			if (bounds.max.y < maxy)
				bounds.max.y = maxy;
		}
	}
	
	return bounds;
}

//-------------------------------------------------------------------------------------
//	Concat
//-------------------------------------------------------------------------------------
GfxPath.prototype.Append = function(pathToAppend)
{
	this.gfxpath = this.gfxpath.concat(pathToAppend.gfxpath);
}

//------------------------------------------------------------
//
//	GfxDrawing (object/API)
//
//------------------------------------------------------------
//
function GfxDrawing()
{
	this.pathList = [];
}

//	Default path properties
GfxDrawing.defaultPathSettings = 
	{
	//	id:				undefined,
		fillPath:		false,
		fillColor:		"#000000",
		strokePath:		true,
		strokeColor:	"#000000",
		strokeWidth:	1
	}

GfxDrawing.prototype.GetPathCount = function()
{
	return this.pathList.length;
}

GfxDrawing.prototype.AddPath = function(gfxPath, settings = undefined, pathId = undefined)
{
	var path = {gfxPath: gfxPath, settings: {}};
	
	if (settings != undefined)
		Object.assign(path.settings, settings);
	
	if (pathId != undefined)
		Object.assign(path.settings, {id: pathId});
		
	this.pathList.push(path);	
}


GfxDrawing.prototype.GetGfxPath = function(pathIdx)
{
	var path = undefined;

	if (pathIdx >= 0 && pathIdx < this.pathList.length)
		path = this.pathList[pathIdx];

	return path.gfxPath;
}

GfxDrawing.prototype.GetGfxPathById = function(pathId)
{
	var path = undefined;
	
	for (var pathIdx = 0; pathIdx < this.pathList.length && path == undefined; pathIdx++)
		if (this.pathList[pathIdx].settings.id == pathId)
			path = this.pathList[pathIdx];

	return path.gfxPath;
}


GfxDrawing.prototype.GetPathSettings = function(pathIdx)
{
	var path = undefined;

	if (pathIdx >= 0 && pathIdx < this.pathList.length)
		path = this.pathList[pathIdx];

	return path.settings;
}

GfxDrawing.prototype.SetPathSettings = function(pathIdx, settings)
{
	var path = undefined;

	if (pathIdx >= 0 && pathIdx < this.pathList.length)
		path = this.pathList[pathIdx];

	Object.assign(path.settings, settings);
}


GfxDrawing.prototype.FindBounds = function(bounds = undefined)
{
	for (var pathIdx = 0; pathIdx < this.pathList.length; pathIdx++)
	{
		var path = this.pathList[pathIdx];
		let margin = (path.settings.strokePath) ? path.settings.strokeWidth : 0;
		bounds = path.gfxPath.FindBounds(bounds, margin)
	}
			
	return bounds
}



export { GfxPath, GfxDrawing };
